/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { faAngleLeft, faAngleRight } from "@fortawesome/pro-regular-svg-icons";
import { LAYER_TYPE } from "../../../../actions/Layers/constants";
import { Button } from "../../../Helper/Button";
import useRipeningRoom, { DATE_URL_FORMAT, useGetAllocatedLayers } from "../hooks/useRipeningRoom";
import { RipeningDayRoom } from "./RipeningDayRoom";

export default function RipeningRoomDays() {
    const { today, fruit_type_config, registerData, checkSessions, checks, todayRegisterData, prev, next, dateRange, firstDayInRange, isDateRangePinned } = useRipeningRoom();
    const isToday = firstDayInRange.isSame(today.add(28, "day"), "day");
    const getAllocatedLayers = useGetAllocatedLayers();
    const ripeningField = fruit_type_config?.ripening_fields?.[0];


    return (
        <div className="mx-n2" >
            <div className="d-flex justify-content-between pt-0">
                {!isDateRangePinned && (
                    <div className="d-none d-md-flex align-items-center">
                        <Button
                            onClick={prev}
                            className="mx-2"
                            color="primary"
                            icon={faAngleLeft}
                        />
                    </div>
                )}

                <div className="d-flex flex-nowrap py-3" css={css`overflow-x: auto;`}>
                    {dateRange.map((date, index) => (
                        <div key={index} className="p-0 px-2">
                            <RipeningDayRoom
                                selected={date.isSame(today, "day")}
                                date={date}
                                pallets={getAllocatedLayers(date, LAYER_TYPE.PALLET)}
                                ripeningField={ripeningField}
                                checkSessions={checkSessions}
                                checks={checks}
                                registerData={date.isSame(today, "day") ? todayRegisterData : registerData.find((i) => i.date === date.format(DATE_URL_FORMAT))}
                            />
                        </div>
                    ))}
                </div>

                {!isDateRangePinned && (
                    <div className={`d-none d-md-flex align-items-center ${(isToday ? "opacity-50" : "")}`}>
                        <Button
                            onClick={next}
                            className="mx-2"
                            disabled={isToday}
                            color="primary"
                            icon={faAngleRight}
                        />
                    </div>
                )}

            </div>
        </div>
    );
}
